import { tns } from 'tiny-slider/src/tiny-slider'

class InfoCarousel {
    constructor(element) {
        if (!element) return

        this.element = element

        this._iniCarousel()
    }

    _iniCarousel() {
        this.carouselElem = this.element.querySelector('.s-info-carousel__items')

        this.carousel = tns({
            container: this.carouselElem,
            items: 4,
            slideBy: 1,
            nav: false,
            mouseDrag: true,
            loop: false,
            controlsPosition: 'bottom',
            controlsText: ['', ''],
            edgePadding: 0,
            gutter: 16,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 2,
                },
                768: {
                    items: 3,
                },
                1024: {
                    items: 4,
                },
            },
        })
    }
}

export default InfoCarousel
